// frontend/src/utils/formatPhoneNumber.js
export const formatPhoneNumber = (value) => {
  if (value.length === 11) {
    return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
  }
  return value;
};
